<template>
  <!-- Komponent odpowiedzialny za wybór rozdzielczości statystyk -->
  <div class="resolution">
    <!-- Nagłówek sekcji: wyświetla przetłumaczony klucz 'resolution' i zamienia na wielkie litery -->
    <h3
      class="margin-0"
      :class="{
        'text-danger':
          this.store.error &&
          (this.store.requireFields.includes('statResolutionUnit') ||
            this.store.requireFields.includes('statResolutionValue')),
      }"
    >
      {{ t('resolution').toUpperCase() }}
    </h3>
    <!-- Kontener z elementem <select> -->
    <div class="select">
      <select
        class="form-select"
        name="Resolution"
        v-model.lazy="value"
        :disabled="store.disabledFields?.resolution"
      >
        <!-- Generowanie opcji na podstawie tablicy resolutionOptions w store -->
        <option
          v-for="(option, index) in store.resolution"
          :key="index"
          :value="index"
        >
          {{ option }} <!-- Tłumaczenie wartości option -->
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { watch, ref } from "vue";

export default {
  name: "ResolutionFilter", // Nazwa komponentu
  props: {
    store: { required: true }, // Przekazany store zawierający filtry i opcje
  },
  setup(props) {
    // Reaktywna zmienna przechowująca wybraną jednostkę rozdzielczości
    const value = ref(props.store.filters.statResolutionUnit ?? "");
    // Funkcja zapisująca wybraną wartość w store
    const saveValue = (text) => {
      props.store.addItem("Resolution", text);
    };

    // Obserwujemy zmianę value i zapisujemy ją, jeśli nie jest pusta
    watch(value, (newValue) => {
      if (value.value !== "") {
        saveValue(newValue);
      }
    });

    return { value };
  },
  created() {
    // Obserwujemy zmiany w store.filters.statResolutionValue, aby wyczyścić wartość, gdy filter zostanie usunięty
    this.$watch(
      () => this.store.filters.statResolutionValue,
      () => {
        this.setEmpty(this.store.filters.statResolutionValue);
      }
    );
    // Obserwujemy zmianę jednostki, aby zaktualizować wartość selecta
    this.$watch(
      () => this.store.filters.statResolutionUnit,
      () => {
        this.value = this.store.filters.statResolutionUnit;
      }
    );
  },
  methods: {
    /**
     * Ustawia wartość selecta na pustą, gdy filter zostanie usunięty
     */
    setEmpty(value) {
      if (value) return; // Jeśli istnieje wartość, nic nie rób
      this.value = ""; // W przeciwnym razie wyczyść select
    },
  },
};
</script>

<style scoped>

.resolution {
  width: 301px;
  min-height: 140px;
}
.resolution h3 {
  padding: 0.85rem 1rem 0.9rem 1rem;
  width: 100%;
  border-bottom: 1px solid #bfbfbf;
  border-top: 1px solid #bfbfbf;
  /* border-right: 1px solid #bfbfbf; */
}

.select {
  border-bottom: 1px solid #bfbfbf;
  /* border-right: 1px solid #bfbfbf; */
  padding: 5px 5px 5px 5px;
}

.select select {
  max-width: 290px;
  border-radius: 0;
  height: 37px;
  font-size: 12px;
}

</style>
